import {Card} from "antd";
import styled from 'styled-components';


export const NoPaddingCard = styled(Card)`
  .ant-card-body {
      padding: 0;
  }
`
